import { transition, trigger, useAnimation } from '@angular/animations';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { pulse } from '@freelancer/animations';
import { IconColor } from '@freelancer/ui/icon';

@Component({
  standalone: false,
  selector: 'fl-showcase-likes',
  template: `
    <fl-button
      class="LikeButton"
      (click)="toggleLiked()"
    >
      <div class="LikeElements">
        <fl-icon
          class="mr-xxsmall"
          [name]="'ui-heart'"
          [color]="isLiked ? IconColor.PRIMARY : IconColor.FOREGROUND"
          [useIconFont]="true"
          [fillIconFont]="isLiked"
          [@pulseAnimation]="numberOfLikes"
        ></fl-icon>
        <p>{{ numberOfLikes }}</p>
      </div>
    </fl-button>
  `,
  styleUrls: ['./showcase-likes.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [
    trigger('pulseAnimation', [
      transition(':enter, :increment, :decrement', [
        useAnimation(pulse, {
          params: {
            duration: '250',
            fromScale: '0.85',
            toScale: '1.2',
          },
        }),
      ]),
    ]),
  ],
})
export class ShowcaseLikesComponent {
  IconColor = IconColor;

  @Input() isLiked = false;
  @Input() numberOfLikes = 0;

  @Output() likeClicked = new EventEmitter<void>();

  toggleLiked(): void {
    this.likeClicked.emit();
  }
}
